@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.clusters
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.dto.core.DateTimeDto

data class LocationsClusterDto(
    val id: KmmLong?,
    val passengerId: KmmLong,
    val centerLat: Double,
    val centerLng: Double,
    val lastRideOn: DateTimeDto,
    val frequency: Int,
    val address: String?,
    val score: Double,
)
